const testimonials = [
  {
    name: "Michael T.",
    location: "Columbia, SC",
    rating: 5,
    text: "Work conference in Germany in 5 days. My passport was expired and I panicked. Fast Passport Center walked me through the entire process. Shipped from the UPS on Garners Ferry Road and had my renewed passport in 4 days. They are absolutely incredible.",
    service: "Emergency Passport",
  },
  {
    name: "Sandra K.",
    location: "Lexington, SC",
    rating: 5,
    text: "We were planning a Caribbean family trip and realized two of our children's passports were expired. Fast Passport Center handled both renewals at the same time. Everything arrived in 7 days. Couldn't have been smoother.",
    service: "Passport Renewal",
  },
  {
    name: "David R.",
    location: "West Columbia, SC",
    rating: 5,
    text: "First-time passport and I had no idea what I was doing. They told me exactly which USC area post office to visit for the acceptance appointment, sent a checklist, and had my passport back in 9 business days. Honestly stress-free.",
    service: "New Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function ColumbiaTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Columbia Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Columbia, Lexington, Irmo, and the Midlands who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">&ldquo;{t.text}&rdquo;</p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">{t.service}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}